import { useNavigate } from "react-router-dom";
import { CampaignActionType, ICampaign } from "../../App/Typings/Campaigns";

export default function ViewCampaignState() {
  const navigate = useNavigate();
  const handleOpenViewCampaignDialog: CampaignActionType = (campaign: ICampaign) => {
    navigate(`/leadcapture/forms/${campaign.id}`);
  };
  return {
    handleOpenViewCampaignDialog,
  } as const;
}
